import { BlockTitle } from "@blocks/Blocks";

import HowDoIKnowSection from "./HowDoIKnowSection";
import PublicitySection from "./PublicitySection";
import ShortListedSection from "./ShortListedSection";
import ShortListingCriteriaSection from "./ShortListingCriteriaSection";

/**
 * Component to render Winners section for FAQ Page
 */
const ShortListingSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="Shortlisting Stage"
        rootClassName="bg-gray-150 lg:text-xl font-medium py-6 pl-4 font-poppins"
      />

      <HowDoIKnowSection />

      <ShortListedSection />

      <ShortListingCriteriaSection />

      <PublicitySection />
    </>
  );
};

export default ShortListingSection;
